import React from 'react';
import { useLocation } from 'react-router-dom';

import DashboardControl, { AjaxRemoteService, Extensions } from 'devexpress-dashboard-react';
import { connect } from "react-redux";
const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
const ViewDxDashboard = (props) => {
  const query = useQuery();
  const rowid = query.get('rowid');
  var accessToken = props.oidc.user.access_token;
  var url = `${window._env_.REACT_APP_APIS}/devexpressDashboard`;
  const getToken = () => {
    return accessToken;
  };
  // dashboardId as a prop so the control loads it once itself; the imperative loadDashboard() in an effect
  // showed the "cannot be found" toast twice.
  return (
    <div style={{ width: "100%", height: "100%", position: 'relative', top: '0px', left: '0px', right: '0px', bottom: '0px' }}>
      <DashboardControl style={{ height: '100%' }}
        dashboardId={rowid}
        workingMode='ViewerOnly'
        DataSourceCacheEnabled="false"
        endpoint={url}>
        <AjaxRemoteService
          headers={{
            'Authorization': `Bearer ${getToken()}`
          }}
        />
      </DashboardControl>
    </div>
  );
}
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(ViewDxDashboard); 